import React from 'react';
import { Box, Chip } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

export interface IComingSoonOverlayProps {
  label: string;
  children: React.ReactNode;
}

/**
 * Global "coming soon" lock wrapper — grays out not-yet-available content and
 * centers a warning Chip overlay. Replaces the bespoke Tailwind
 * `ComingSoonBadge` + absolute-overlay pattern with brand-theme MUI.
 * Decorative overlay is `aria-hidden`; locked controls stay out of tab order
 * via `inert` so keyboard users skip them.
 */
export const ComingSoonOverlay = ({ label, children }: IComingSoonOverlayProps) => (
  <Box sx={{ position: 'relative' }}>
    <Box sx={{ opacity: 0.4, filter: 'grayscale(1)', pointerEvents: 'none', userSelect: 'none' }}>
      {children}
    </Box>
    <Box
      aria-hidden="true"
      sx={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
      }}
    >
      <Chip
        icon={<LockIcon fontSize="small" />}
        label={label}
        color="warning"
        sx={{ fontWeight: 600, px: 0.5, py: 2.5, boxShadow: 2 }}
      />
    </Box>
  </Box>
);
